export default {
  getShippings: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/transports/getters.js